import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Gallery from "react-grid-gallery";
import PageHeader from "../../components/PageHeader";
import { getListingsReferral } from "../../services/listings";
import {
  getPropertyUnit,
  getPropertyUnitLeaseSettings,
} from "../../services/units";
import { getProperty } from "../../services/properties";
import { createListingApplication } from "../../services/listings";
import Layout from "../../components/Layout";
import { TextField, Checkbox } from "../../components/form";
import Loading from "../../components/Loading";
import ListingUnitInfos from "../../components/ListingUnitInfos";
import { getIcon, getRatingAverage } from "../../utils";
import { APPLY_VALIDATION_SCHEMA as validationSchema } from "../../constants/validation";
import "./styles.css";
import { getPropertyLease } from "../../services/leases";

function WebsitePublicListing(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [propertyLeaseSettings, setPropertyLeaseSettings] = useState();
  const [error, setError] = useState("");
  const history = useHistory();
  const id = props.match.params?.id;
  const [listing, setListing] = useState();
  const [property, setProperty] = useState();
  const [unit, setUnit] = useState();
  const [unitLeaseSettings, setUnitLeaseSettings] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [photoUrls, setPhotoUrls] = useState([]);
  const layoutRef = useRef();

  useEffect(() => {
    getListingsReferral(id).then((data) => {
      setListing(data[0]);
      setPhotoUrls(data[0].photoUrls);
    });
  }, [id]);

  useEffect(() => {
    const load = async () => {
      if (listing && listing.id) {
        const property1 = await getProperty(listing.propertyId)
        setProperty(property1);
        getPropertyLease(property1.id).then((data) => {
          setPropertyLeaseSettings(data);
        });
        getPropertyUnit(listing.propertyId, listing.unitId).then((data) => {
          setUnit(data);
        });
        getPropertyUnitLeaseSettings(listing.propertyId, listing.unitId).then(
          (data) => {
            setUnitLeaseSettings(data);
          }
        );
      }
    }
    load();
  }, [listing]);

  useEffect(() => {
    if (property && unit && unitLeaseSettings) {
      setIsLoading(false);
    }
  }, [property, unit, unitLeaseSettings]);

  const handleClickOpen = (e) => {
    e.preventDefault();
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setError("");
  };

  const rating = getRatingAverage(listing?.ratings);

  const onSubmit = (values) => {
    createListingApplication(listing.id, {
      email: values.email,
      firstName: values.firstName,
      lastName: values.lastName,
    }).then((data) => {
      if (data.errorsDetails) {
        setError(data.errorsDetails[0].message);
      } else {
        setShowConfirmation(true);
      }
    });
  };

  if (isLoading) {
    // For some reason, property.address get loaded as a child in Layout
    // even if isLoading === false
    return <Loading />;
  }

  const IMAGES = [];

  listing?.photoUrls.forEach((url, index) => {
    const isSelected = false;
    let thumbnailWidth = "30%";
    let thumbnailHeight = "135px";
    if (index == 0) {
      thumbnailWidth = "30%";
      thumbnailHeight = "286px";
    }
    IMAGES.push({
      src: url,
      thumbnail: url,
      thumbnailWidth,
      thumbnailHeight,
      isSelected,
      caption: "",
    });
  });

  return (
    <>
      <Layout isLoading={isLoading} className="public-listing">
        <PageHeader
          title={`${property.address.street}, ${property.address.city}, ${property.address.subdivision}, ${property.address.city}, ${property.address.postalCode}`}
          subTitle={
            <div className="stars">
              {[...Array(rating)].map((item, index) => getIcon("STAR", index))}
            </div>
          }
        >
          <Grid container spacing={1}>
            <Grid mr={2}>
              <Button
                variant="contained"
                onClick={handleClickOpen}
                size="small"
              >
                Apply
              </Button>
            </Grid>
          </Grid>
        </PageHeader>
        <Box sx={{ gridArea: "main" }}>
          <div className="gallery">
            <Gallery enableImageSelection={false} images={IMAGES} />
          </div>
          <ListingUnitInfos
            property={property}
            unit={unit}
            listing={listing}
            propertyLeaseSettings={propertyLeaseSettings}
            unitLeaseSettings={unitLeaseSettings}
          />
        </Box>
      </Layout>
      <Dialog open={isOpen} onClose={handleClose} scroll="paper">
        <DialogTitle>Apply for a lease</DialogTitle>
        <DialogContent>
          {showConfirmation && <p>The application has been sent. Thank you!</p>}
          {!showConfirmation && (
            <Formik
              initialValues={{
                firstName: "",
                email: "",
                lastName: "",
                agreement: false,
              }}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <Grid container mt={2}>
                    <Grid item xs={6}>
                      <TextField
                        name="email"
                        type="email"
                        placeholder="Email"
                        variant="standard"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        name="emailConfirmation"
                        type="email"
                        placeholder="Confirm email"
                        variant="standard"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        name="firstName"
                        type="text"
                        placeholder="First Name"
                        variant="standard"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        name="lastName"
                        type="text"
                        placeholder="Last Name"
                        variant="standard"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <p>
                        RentBeets does not participate in the vetting of
                        Tenants. RentBeets only provides tenant screening
                        information screened by TransUnion Smartmove to
                        Landlords or Property Managers so that they can take the
                        proper measures for signing a new tenant while complying
                        with Equal Housing Opportunity and Fair Housing Act.
                        TransUnion Tenant Screening does include Credit-Based
                        Resident Score, National Criminal Background Report,
                        Full Credit Report, National Eviction Related Report**,
                        Income Insights. For Further information on this report
                        please visit &nbsp;
                        <a href="https://www.mysmartmove.com/" target="_blank">
                          Tenant Screening
                        </a>
                        .
                      </p>
                      <p>
                        By clicking accept, you (Prospective Tenant Name) are
                        agreeing that RentBeets may share the TransUnion
                        Smartmove Tenant Screening with (Property Manager Name)
                        who is deemed responsible for Apartment (Address and
                        apartment number).
                      </p>
                      <p>
                        I (Prospective Tenant Name) agree to share my Tenant
                        Screening Score only for (Address and Apartment Number)
                        to the Property Manager/Landlord (Property
                        Manager/Landlord Name)
                      </p>
                      <Checkbox label="I accept" name="agreement" />
                    </Grid>
                    {error && (
                      <Grid item xs={12}>
                        <p className="error-message">
                          <small>{error}</small>
                        </p>
                      </Grid>
                    )}
                    <Grid item xs={12} style={{ textAlign: "right" }}>
                      <Button type="submit">Apply</Button>
                    </Grid>
                  </Grid>
                </form>
              )}
            </Formik>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}

export default WebsitePublicListing;
